<template>
    <div id="app" class="newyear-2021-theme" :class="projectHost">
        <!-- SCRIPTS -->
        <noscript v-if="gtmNoscript != null"><iframe :src="'https://www.googletagmanager.com/ns.html?id=GTM-' + gtmNoscript" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
        <noscript v-if="yandexNoScript != null"><div><img :src="'https://mc.yandex.ru/watch/' + yandexNoScript" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
        <!-- END SCRIPTS -->
        <vue-topprogress ref="topProgress" :color="getColor()" :minimum="70" :speed="450"></vue-topprogress>
        <div class="wrapper">
            <div class="wrapper-in">
                <formLandModal v-if="isOpenFormLandModal"></formLandModal>
                <BanerTopVertical :options="[{page: 'sales-land-page'}]" v-if="banerSystem != undefined && banerSystem.baner_system_active == 'true' && salesCard != null && salesCard.project_dev_init != null && salesCard.project_dev_init != 'true'"></BanerTopVertical>
                <AppHeader :class="{'banerOnline' : banerSystem != undefined && banerSystem.baner_system_active == 'true' && banerTopCoockieVisible == true, 'yassytower-header': projectHost == 'yassytower'}" v-if="salesCard != null && salesCard.project_dev_init != null && salesCard.project_dev_init != 'true'"></AppHeader>
                <mobileSidebar :class="{'banerOnline' : banerSystem != undefined && banerSystem.baner_system_active == 'true' && banerTopCoockieVisible == true}" v-if="salesCard != null && salesCard.project_dev_init != null && salesCard.project_dev_init != 'true'"></mobileSidebar>
                <main class="content" :class="{'banerOnline' : banerSystem != undefined && banerSystem.baner_system_active == 'true' && banerTopCoockieVisible == true}">
                    <home v-if="salesCard != null && salesCard.project_dev_init != null && salesCard.project_dev_init != 'true'"></home>
                    <devPage v-if="salesCard != null && salesCard.project_dev_init != null && salesCard.project_dev_init == 'true'"></devPage>
                </main>
                <formConsult v-if="salesCard != null && salesCard.project_dev_init != null && salesCard.project_dev_init != 'true'"></formConsult>
                <AppFooter v-if="salesCard != null && salesCard.project_dev_init != null && salesCard.project_dev_init != 'true'"></AppFooter>
            </div>
        </div>
        <transition
            name="fade"
            mode="out-in"
        >
            <div class="body-overlay" id="body-overlay" @click="closeMobileMenu(!openSendwich)" v-cloak v-if="openSendwich || openFormConsult || isOpenFormLandModal" :class="{'openFormConsult': openFormConsult, 'openFormLandModal' : isOpenFormLandModal}"></div>
        </transition>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import AppHeader from '@/components/header/header.vue'
    import AppFooter from '@/components/footer/footer.vue'
    import BanerTopVertical from '@/components/baner-system/baner-top-vertical.vue'
    import formConsult from '@/components/forms/form-consult.vue'
    import mobileSidebar from '@/components/mobile-sidebar/mobile-sidebar.vue'
    import formLandModal from '@/components/forms/form-land-modal.vue'
    // import burgerMenu from '@/components/burger-menu/burger-menu.vue'
    // import secretBtns from '@/components/partials/secret-btns.vue'
    import home from '@/views/home.vue'
    import devPage from '@/views/dev-page.vue'
    import cookie from 'vue-cookie'

    export default {
        metaInfo() {
            if (window.host == 'orion') {
                this.title = 'ЖИЛОЙ КОМПЛЕКС ORION II от BAZIS-A. ПРОСТОРНЫЕ АПАРТАМЕНТЫ';
                this.contentDescription = 'На пересечении проспектов Назарбаева и Аль-Фараби. Символ города, знакомый каждому. Личный парк. Лучшие виды на горы и город!';
            } else if (window.host == 'aqualina') {
                this.title = 'Жилой комплекс-курорт AQUALINA RESORT от BAZIS-A в Актау';
                this.contentDescription = 'Частные виллы, таунхаусы и апартаменты на берегу Каспийского моря. AQUALINA RESORT - больше чем дом, лучше чем курорт!';
            } else if (window.host == 'akvarel') {
                this.title = 'Семейный квартал «Акварель» от BAZIS-A в Алматы';
                this.contentDescription = 'Ипотека без залога. Просторные квартиры от 37 до 85 м2. Собственный детский сад. Благоустроенный двор. Подземный паркинг. Рядом с ТРК ADK';
            } else if (window.host == 'jazzkvartal') {
                this.title = 'JAZZ-квартал от BAZIS-A в Алматы';
                this.contentDescription = 'Рассрочка 50/50. 2-3-4-комнатные квартиры от 72 до 120 м2. Напротив ТРК ADK. Отличная транспортная доступность. Рядом ст.м. Сайран';
            } else if (window.host == 'austria') { 
                this.title = 'Жилой комплекс AUSTRIA от BAZIS-A в Астане';
                this.contentDescription = '';
            } else if (window.host == 'auezovcity') { 
                this.title = 'Новый жилой комплекс AUEZOV CITY от BAZIS-A в Алматы';
                this.contentDescription = 'Начало продаж! Для вас 1- и 2-комнатные квартиры от 41 до 75 м2 на Гоголя-Ауэзова. Хорошая транспортная доступность. Развитая инфраструктура.';
                this.keyWordsContent = 'ауезов сити, алматы, ауезов сити базис-а, auezov city, жк на ауэзова от базис-а, bazis-a, almaty';
            } else if (window.host == 'shahristan') {
                this.title = 'Жилой комплекс SHAHRISTAN от BAZIS-A в Шымкенте';
                this.contentDescription = 'Начало продаж! Просторные 2- и 3-комнатные квартиры от 76 до 106 м2 в новом административно-деловом центре города. Рядом с городским акиматом';
            } else if (window.host == 'primavera') {
                this.title = 'ЖИЛОЙ КОМПЛЕКС PRIMAVERA от BAZIS-A – It’s my life ';
                this.contentDescription = 'На проспекте Аль-Фараби и ул. Ходжанова. Знаковое окружение, уютные дворы, авторские лобби, видовые 1-, 2-, 3- и 4-комнатные квартиры.';
            } else if (window.host == 'alfarabi27') {
                this.title = 'Al’Farabi 27 от Bazis-A. Принадлежит только вам!';
                this.contentDescription = 'Новый жилой комплекс на Аль-Фараби-Сейфуллина. 2-3-4-комнатные квартиры от 50 до 153 м2. Рядом оздоровительный SPA & Fitness Center. Рассрочка 50/50.';
            } else if (window.host == 'aman') {
                this.title = 'AMAN – жилой комплекс от BAZIS-A в Астане';
                this.contentDescription = 'По пр. Мангилик Ел рядом с выставочным комплексом EXPO. Функциональные 1-2-3-комнатные квартиры от 32,8 до 73,5 м2. Хорошая транспортная доступность';
            } else if (window.host == 'estet') {
                this.title = 'ESTET – жилой комплекс в Алматы от BAZIS-A';
                this.contentDescription = 'По ул. Розыбакиева ниже пр. Аль-Фараби. Неоклассическая архитектура, огромное парковое пространство для прогулок, игр и спорта, квартиры 50–139 м2.';
            } else if (window.host == 'qazyna') {
                this.title = 'Жилой комплекс QAZYNA от BAZIS-A в Астане';
                this.contentDescription = '1-, 2- и 3-комнатные квартиры от 38 м2 до 108 м2 в районе Аллеи Мынжылдык, рядом с новым театром. Рассрочка от застройщика.';
            } else if (window.host == 'soho2') {
                this.title = 'ЖИВИТЕ В СТИЛЕ SOHO2';
                this.contentDescription = 'SOHO – это мегаполис в миниатюре от BAZIS-A! Жилые дома, школы и детские сады, развлекательные, спортивные, шопинг и бизнес-центры. Расположен по улице ханов Керея и Жанибека, напротив Президентского парка.';
            } else if (window.host == 'discovery') {
                this.title = 'DISCOVERY жилой квартал – открытие года от BAZIS-A';
                this.contentDescription = 'Жилой квартал DISCOVERY, расположенный на Аллее Тысячелетия – в квадрате улиц А. Байтурсынова и Ж. Нажимиженова, К. Азербаева и М. Жумабаева – показывает, как далеко мы можем зайти в своем стремлении познать мир и познать себя!';
            } else if (window.host == 'zangar') {
                this.title = 'Zangar жилой комплекс от BAZIS-A';
                this.contentDescription = '';
            } else if (window.host == 'orion-3') {
                this.title = 'ORION III - жилой комплекс от BAZIS-A';
                this.contentDescription = '';
            } else if (window.host == 'evolution') {
                this.title = 'EVOLUTION - жилой комплекс от BAZIS-A';
                this.contentDescription = '';
            } else if (window.host == 'kohota') {
                this.title = 'Жилой комплекс Koh Ota от BAZIS-T в Ташкенте';
                this.contentDescription = 'Скоро! Уютные квартиры и сити-хаусы с собственными террасами в исторической части города, рядом с мечетью Кох-Ота';
            } else if (window.host == 'yassytower') {
                this.title = 'Бизнес-центр YASSY TOWER в Туркестане, рядом с областным акиматом';
                this.contentDescription = 'Современные офисные помещения от 63 до 131 м2 в аренду и на продажу. Развитая инфраструктура. Комфортные условия для бизнеса.';
            }
            return {
                title: this.title,
                meta: [
                    { name: 'description', content:  this.contentDescription},
                    { name: 'keywords', content:  this.keyWordsContent},
                ]
            };
        },
        components: {
            AppHeader,
            AppFooter,
            mobileSidebar,
            formConsult,
            formLandModal,
            BanerTopVertical,
            home,
            devPage,
        },
        data () {
            return {
                projectHost: window.host,
                isMobile: false,
                title: '',
                contentDescription: '',
                keyWordsContent: '',
                DomLoaded: false,
                fadeInVisible: false,
                gtmNoscript: null,
                newGtmScript: null,
                jivositeScript: null,
                yandexNoScript: null,
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            banerSystem: 'loadBanerSystem',
            banerTopCoockieVisible: 'loadCockieBanerTopVisible',
            openSendwich: 'loadOpenSendwich',
            openFormConsult: 'loadOpenFormConsult',
            isOpenFormLandModal: 'loadIsOpenFormLandModal',
        }),
        methods: {
            getColor() {
                if (this.projectHost != 'yassytower') {
                    return '#e20036'
                } else {
                    return '#ab9176'
                }
            },
            closeMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
                if (this.isOpenFormLandModal) {
                    cookie.set(window.host + '_form_land_modal_timer', true, { expires: this.salesCard.shablon_drop_modal.minutes + 'm' });
                    this.$store.commit('Open_FormLandModal', false);
                }
            },
            setCockieBanerTop() {
                var cockie = this.$cookie.get('baner_top_shablon_visible');
                // console.log(cockie, 'cockie test')
                if (this.banerSystem != null && this.banerSystem.baner_system_active == 'true' && cockie == null) {
                    this.$cookie.set('baner_top_shablon_visible', true, { expires: '1D' });
                    this.$store.commit('coockieBanerTopVisible', true);
                    // console.log(cockie, 'first_step')
                } else if (this.banerSystem != null && this.banerSystem.baner_system_active == 'true' && cockie == 'true') {
                    this.$store.commit('coockieBanerTopVisible', true);
                    // this.$cookie.set('baner_top_shablon_visible', true, { expires: '1D' });
                    // console.log(cockie, 'first_second')
                } else if (this.banerSystem != null && this.banerSystem.baner_system_active == 'true' && cockie == 'false') {
                    // this.$store.commit('coockieBanerTopVisible', false);
                    // console.log(cockie, 'first_third');
                } else {
                    return false;
                }
            },
            setNonScriptToBody() {
                var host = window.host;
                // console.log(host);
                if (host == 'orion') {
                    this.yandexNoScript = '71345077';
                    this.gtmNoscript = 'TF4B7C8';
                    this.jivositeScript = "yBq3whJcms"; 
                    this.addJivoToTemplate(this.jivositeScript);
                    // console.log(this.gtmNoscript, this.jivositeScript)
                } else if (host == 'orion-iii') {
                    this.gtmNoscript = 'PS4D74F';
                    this.jivositeScript = "oH8ze6t5lw"; 
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'orion-3') {
                    this.gtmNoscript = 'PS4D74F';
                    this.jivositeScript = "oH8ze6t5lw"; 
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'aqualina') {
                    this.yandexNoScript = '71344948';
                    this.gtmNoscript = 'PDHSPCX';
                    this.jivositeScript = "45PghDsE5R"; 
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'akvarel') {
                    this.yandexNoScript = '71501437';
                    this.gtmNoscript = 'K6WLBTL';
                    this.jivositeScript = 'Sylrzjyswh';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'jazzkvartal') {
                    this.yandexNoScript = '71747563';
                    this.gtmNoscript = 'KMJ68TN';
                    this.jivositeScript = 'A2yFXb2asx';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'austria') {
                    this.yandexNoScript = '76923205';
                    this.gtmNoscript = 'W6K55WQ';
                    this.jivositeScript = 'XvIyiVibeU';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'auezovcity') {
                    this.yandexNoScript = '76923130';
                    this.gtmNoscript = 'MNPKFRS';
                    // this.newGtmScript = 'WFJ95LBLT1';
                    this.jivositeScript = 'HDIZFNMxyb';
                    // this.addNewGtmTemplate(this.newGtmScript);
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'shahristan') {
                    this.yandexNoScript = '76923292';
                    this.gtmNoscript = 'N56M25Z';
                    this.jivositeScript = 'vqedFDgUHA';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'primavera') {
                    this.yandexNoScript = '76575103';
                    this.gtmNoscript = 'NBZB2B6';
                    this.jivositeScript = 'J3JGoBOlEi';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'alfarabi27') { 
                    // this.yandexNoScript = '76575103';
                    this.gtmNoscript = 'KFSS8BX';
                    this.jivositeScript = '9XfaXY8cgD';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'aman') { 
                    // this.yandexNoScript = '76575103';
                    this.gtmNoscript = 'W3PTQVJ';
                    this.jivositeScript = 'LJMgSjJ4Oc';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'estet') { 
                    // this.yandexNoScript = '76575103';
                    this.gtmNoscript = '54G7JZ7';
                    this.jivositeScript = 'Vn3U7rNx7r';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'qazyna') { 
                    // this.yandexNoScript = '76575103';
                    this.gtmNoscript = 'MT7PG42';
                    this.jivositeScript = 'LlFrqokJdQ';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'zangar') { 
                    // this.yandexNoScript = '76575103';
                    this.gtmNoscript = 'TBBCLJ3';
                    this.jivositeScript = 'iiHbqrb4rN';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'soho') { 
                    this.yandexNoScript = '58011877';
                    this.gtmNoscript = 'MFQZ597';
                    this.jivositeScript = 'HbphucK0yG';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'soho2') { 
                    this.yandexNoScript = '58011877';
                    this.gtmNoscript = 'MFQZ597';
                    this.jivositeScript = 'HbphucK0yG';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'discovery') { 
                    this.yandexNoScript = '56941696';
                    this.gtmNoscript = 'P92S93Q';
                    this.jivositeScript = 'STueZFff9y';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'evolution') {
                    this.jivositeScript = 'RFt7t7IS71';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'kohota') { 
                    // this.yandexNoScript = '76575103';
                    this.gtmNoscript = 'TRKW7V8';
                    if (this.lang == 'uz/') {
                        this.jivositeScript = 'pe6DgUNkJQ';
                    } else {
                        this.jivositeScript = 'RDKyl0DAlS';
                    }
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (host == 'yassytower') {
                    this.yandexNoScript = '76575232';
                    this.gtmNoscript = 'N359W85';
                    // this.jivositeScript = 'J3JGoBOlEi';
                    // this.addJivoToTemplate(this.jivositeScript);
                }
            },
            addJivoToTemplate(key) {
                // console.log(key);
                let externalScript = document.createElement('script')
                externalScript.setAttribute('src', '//code.jivosite.com/widget/' + key)
                // document.body.appendChild(externalScript)
                document.body.prepend(externalScript)
            },
            addNewGtmTemplate(key) {
                let externalScript = document.createElement('script')
                externalScript.setAttribute('src', 'www.googletagmanager.com/gtag/js?id=G-' + key)
                // document.body.appendChild(externalScript)
                document.body.prepend(externalScript)
            },
            checkFormLandModal() {
                // console.log(this.salesCard);
                if (this.salesCard != null) {
                    if (this.salesCard.shablon_drop_modal != undefined && this.salesCard.shablon_drop_modal.init == 'true') {
                        const seconds = parseInt(this.salesCard.shablon_drop_modal.seconds) * 1000;
                        var timerCockie = cookie.get(window.host + '_form_land_modal_timer');
                        setTimeout(() => {
                            // console.log(seconds);
                            if (timerCockie == null) {
                                // console.log(seconds, 'SECONDS', timerCockie);
                                this.$store.commit('Open_FormLandModal', true);
                            } 
                            // else { // если кука есть какие то действия при необходимости
                            //     console.log(timerCockie, 'COCKIE TIMER');
                            // }
                        }, seconds);
                    } 
                    // else {
                    //     // console.log('FORM LAND MODAL IS FFFFFALLLLLLSEEEEE ')
                    // }
                }
            },
            // MOBILE CHECKER
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                } else {
                    this.iSmobile = false
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
            if (localStorage.getItem('language') === null) {
                localStorage.setItem('language', '');
            }
            // console.log(window.location)
            // REDIRECTS
            if (window.location.origin == 'https://soho.bazis.kz') {
                window.location.href = 'https://soho2.bazis.kz'
            } else if (window.location.origin == 'https://orion-iii.bazis.kz') {
                window.location.href = 'https://orion-3.bazis.kz'
            }
            // END
            // PROJECT HARD SETUP
            if (window.host == 'test') {
                window.host = 'kohota'
            } else if (window.host == 'discovery-test') {
                window.host = 'discovery'
            } else if (window.host == 'localhost:8080') {
                window.host = 'jazzkvartal'
            } else if (window.host == 'soho') {
                window.host = 'soho2'
            } else if (window.host == 'orion-iii') {
                window.host = 'orion-3'
            } 
            this.$store.dispatch('getCrmAuthToken').then((response) => {
                this.$store.dispatch('getFlatsPageData');
                this.$store.dispatch('getFullSetUpProject').then((response) => {
                    this.setCockieBanerTop();
                });
                this.$store.dispatch('getContactsPageData');
                this.$store.dispatch('getSalesCardPageData');
                this.$store.dispatch('getSaleItemFiltersParams', window.host);
                this.$store.dispatch('getSaleItemCard', window.host);
                this.$store.dispatch('getSalesCardContent', window.host);
            });
            // END
            
        },
        created () {
            this.setNonScriptToBody();
        },
        destroyed() {
        },
        mounted() {
            this.isMobileCheck();
            this.checkResize();
            this.$refs.topProgress.start();
            this.$store.watch(
                (state) => state.salesCardContent,
                (newValue) => {
                    if (newValue != null) {
                        this.$refs.topProgress.done();
                    }
                }
            ),
            this.$store.watch(
                (state) => state.salesCardContent,
                (newValue) => {
                    if (newValue != null) {
                        this.checkFormLandModal();
                    }
                }
            )
        }
    }
</script>

<style>
.grecaptcha-badge {
    opacity: 0 !important;
    visibility: hidden;
}
</style>